import React, {useState} from 'react';
import {Button, Flex} from "antd";
import {useViewerStore} from '../../../../../store/store';
import completedIcon from "../../../../../assets/img/icons/completed-icon.png";
import errorIcon from "../../../../../assets/img/icons/error-icon.png";
import { getACADExcelFile } from '../../../../../services/aCADFileService';

const ACADPopup = () => {

    const {sceneViewer, designList, selectedDesignIndex, financePartnerDetails} = useViewerStore();
    const [ACADGenerationStatus, setACADGenerationStatus] = useState('default');

    const confirmGenerateACAD = async () => {
        setACADGenerationStatus('generating');
        const selectedDesign = designList[selectedDesignIndex];
        const opportunityId = sessionStorage.getItem('SalesForceId') || '';
        const acadFileData = await getACADExcelFile(opportunityId, String(selectedDesign.DesignID), financePartnerDetails);
        if (!acadFileData) {
            setACADGenerationStatus('error');
            return;
        }
        setACADGenerationStatus('success');
        const url = window.URL.createObjectURL(new Blob([acadFileData]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `ACAD CALC TEMPLATE.xlsx`);
        document.body.appendChild(link);
        link.click();
    }

    const cancel = () => {
        //Close Alert
        sceneViewer.viewerAlert({show: false});
    };

    return (
        <>
            {
                ACADGenerationStatus === 'success' ? (<Flex vertical justify={'center'} align={'center'}>                      
                    <p className="report-text">ACAD Template Generated Successfully</p>
                    <img
                        src={completedIcon}
                        alt={"Completed Icon"}
                        width={50}
                        height={50}
                    />
                </Flex>) : ACADGenerationStatus === 'error' ? (<Flex vertical justify={'center'} align={'center'} gap={5}>
                    <p>ACAD Template Generation Failed</p>
                    <img
                        src={errorIcon}
                        alt={"Error Icon"}
                        width={50}
                        height={50}
                    />
                    </Flex>) : ACADGenerationStatus === 'generating' ? (<Flex justify={'center'} align={'center'} gap={10}>
                        <span className="loader-icon-spinner"></span>
                        <p>Generating ACAD Template</p>

                    </Flex>) :

                    (<>
                        
                        <p className="report-text">Click Confirm to Generate and Download ACAD Template</p>
                        <div className={"modal-bottom-action-button-container"}>
                            <Button
                                id={"confirmSiteReportBtn"}
                                type="primary"
                                size="large"
                                className="editor__control--finalize modal-confirm-button"
                                onClick={confirmGenerateACAD}
                            >
                                Confirm
                            </Button>
                            <Button
                                type="primary"
                                size="large"
                                className="editor__control--finalize modal-cancel-button"
                                onClick={cancel}
                            >
                                Cancel
                            </Button>
                        </div>
                    </>)
            }
        </>
    )
}

export default ACADPopup;